import React from 'react';
import { LeftMenuItem } from '../shared/LeftMenuItem';
import { NotificationFlagsCategories } from '../../../../models/NotificationFlags/NotificationFlagsCategories';

export interface MyReferralHubMenuItemProps {
    withFlag?: boolean;
    className?: string;
    marginLeft?: number;
}

export const MyReferralHubMenuItem = (props: MyReferralHubMenuItemProps) => {
    const withFlag = props.withFlag ?? true;

    return (
        <LeftMenuItem
            icon="pe-7s-share"
            label="My Referral Hub"
            to="/my-referrals"
            flagCode={
                withFlag
                    ? NotificationFlagsCategories.ReferralHubCode
                    : undefined
            }
            className={props.className}
            marginLeft={props.marginLeft}
            trackingAction="My Referrals"
        />
    );
};
